import React, { ReactNode } from 'react'
import { cn } from '~shared/utils/cn'

type Props = {
  children: ReactNode
  className: string
}

export const Badge: React.FC<Props> = ({ children, className }) => {
  return (
    <span
      className={cn(
        'px-[16px] rounded-[16px] flex items-center h-[35px]',
        className
      )}>
      {children}
    </span>
  )
}
